import axios from 'axios';
import Globals from '../Globals';
import { getLogModel } from '../Functions';
import LoggingService from './LoggingService';

const {
    ERROR_LOG_ID,
    ERROR_CODE,
    BFF_PATH: { BASE_URL, BATCHES, VEHICLE },
} = Globals;

class BatchesService {
    constructor() {
        this.serviceUrl = axios.create({
            baseURL: BASE_URL + BATCHES.BASE_PATH,
        });
    }

    methodName = async (body, token) => {
        const { config, data } = this.parseConfig(body, token); //get base config for request
        const response = await this.serviceUrl.post(/*methodEndpoint, data, config*/);
        return this.parseResponse(response); //parse JSONS
    };

    parseConfig = (body, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: ERROR_CODE,
            },
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: ERROR_CODE,
            },
            body: JSON.stringify(body),
        };
        return { config, data };
    };

    parseResponse = response => {
        if (response?.data?.body) {
            const body = JSON.parse(response.data.body);
            if (body.Result) {
                body.Result = JSON.parse(body.Result);
            }
            response.data.body = body;
            return response.data;
        }

        return response;
    };

    /*

  OPEN BATCHES API CALLS

  */

    createBatch = async (body, token) => {
        // {
        //     "Vehicles": [
        //       {
        //         "IdWebVehicles": 0,
        //         "Amount": 0.0
        //       },
        //       {
        //         "IdWebVehicles": 0,
        //         "Amount": 0.0
        //       },
        //       {
        //         "IdWebVehicles": 0,
        //         "Amount": 0.0
        //       },
        //       {
        //         "IdWebVehicles": 0,
        //         "Amount": 0.0
        //       }
        //     ],
        //     "IdCustomer": 0,
        //     "BuyMoment": "04",
        //     "Name": "Nombre del lote"
        //   }
        const { config, data } = this.parseConfig(body, token);
        try {
            const response = await this.serviceUrl.post(
                BATCHES.CREATE_BATCH,
                data,
                config
            );

            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(
                ERROR_LOG_ID,
                error?.config?.url,
                config,
                data,
                error
            );
            new LoggingService().createLog(newError);
        }
    };

    deleteBatch = async (body, token) => {
        const { config, data } = this.parseConfig(body, token);
        const response = await this.serviceUrl.post(
            BATCHES.DELETE_BATCH,
            data,
            config
        );
        return this.parseResponse(response);
    };

    getBatches = async (body, token) => {
        const { config, data } = this.parseConfig(body, token);
        //{ "IdBach": null } -> returns all user Globals.batches, pass an Id to get an specific batch
        const response = await this.serviceUrl.post(
            BATCHES.GET_BATCHES,
            data,
            config
        );
        return this.parseResponse(response);
    };

    editBatchVehicles = async (body, token) => {
        /*
{
  "Vehicles": [
    {
      "IdWebVehicles": 0,
      "Amount": 0.0
    },
    {
      "IdWebVehicles": 0,
      "Amount": 0.0
    },
    {
      "IdWebVehicles": 0,
      "Amount": 0.0
    }
  ],
  "IdBach": 2
}
    */

        const { config, data } = this.parseConfig(body, token);
        const response = await this.serviceUrl.post(
            BATCHES.EDIT_BATCH_VEHICLES,
            data,
            config
        );
        return this.parseResponse(response);
    };

    addVehiclesToBach = async (body, token) => {
        /*
{
  "Vehicles": [
    {
      "IdWebVehicles": 0,
      "Amount": 0.0
    },
    {
      "IdWebVehicles": 0,
      "Amount": 0.0
    },
    {
      "IdWebVehicles": 0,
      "Amount": 0.0
    }
  ],
  "IdBach": 2
}
    */
        const { config, data } = this.parseConfig(body, token);
        const response = await this.serviceUrl.post(
            BATCHES.ADD_VEHICLES_TO_BATCH,
            data,
            config
        );
        return this.parseResponse(response);
    };

    editBatchName = async (body, token) => {
        const { config, data } = this.parseConfig(body, token);
        const response = await this.serviceUrl.post(
            BATCHES.EDIT_BATCH_NAME,
            data,
            config
        );
        return this.parseResponse(response);
    };

    getBatchDetails = async (body, token) => {
        //: { "IdBach": 5 }
        const { config, data } = this.parseConfig(body, token);
        const response = await this.serviceUrl.post(
            BATCHES.GET_BATCH_DETAILS,
            data,
            config
        );
        return this.parseResponse(response);
    };

    deleteBatchVehicle = async (body, token) => {
        // {
        //     "IdBach": 2,
        //     "IdPublishVehicle": 12
        //   }
        const { config, data } = this.parseConfig(body, token);
        const response = await this.serviceUrl.post(
            BATCHES.DELETE_BATCH_VEHICLE,
            data,
            config
        );
        return this.parseResponse(response);
    };

    /*

    CLOSED BATCHES API CALLS

  */

    getClosedBatches = async token => {
        /*
      [
      {
        IdBatch: Int (Id del lote)
        Name: Str (Nombre del lote)
        NumVehicles: Int (Número de vehículos que tiene el lote)
        CreateDate:  Date/Str (Fecha de creación del lote)
        EndDate: Date/Str (Fecha de finalización del lote)
        MaxBid: Int (Cantidad de la máxima puja esto puede que sea a Amazon¿?)
        MaxBidUser: Int (Id del usuario que ha hecho la máxima puja)
        StartAmount: Int (Cantidad de puja inicial/mínima)
        Bid: Boolean (El usuario ha apostado o no a ese lote)
        ImagePath: Str
        ImageHash: Str
        ImageFile: Str
      }
      ]
    */
        const { config, data } = this.parseConfig('', token); //get base config for request
        const response = await this.serviceUrl.post(
            BATCHES.GET_CLOSED_BATCHES,
            data,
            config
        );
        return this.parseResponse(response); //parse JSONS
    };

    getClosedBatchDetails = async (body, token) => {
        /*
      {
      cars: [
        {
        Brand: Str
        Model: {
        ... mismos datos que en el get-bach-details
        }
        IdWebVehicles: Int
        Kms: Int
        ImageHash: Str
        ImagePath: Str
        ImageFile: Str
        AmountOffered: Int (Cantidad que el usuario ha apostado por ese vehículo, si no ha apostado devolver 0)
        }
      ]
      }
    */
        const { config, data } = this.parseConfig(body, token); //get base config for request
        const response = await axios.post(
            BASE_URL + VEHICLE.BASE_PATH + BATCHES.GET_CLOSED_BATCH_DETAILS,
            data,
            config
        );
        return this.parseResponse(response); //parse JSONS
    };

    getClosedBatchBids = async (endpoint, apiKeyName, apiKey, body, token) => {
        const config = {
            headers: {
                [apiKeyName]: apiKey,
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            endpoint,
            JSON.stringify(body),
            config
        );

        return this.parseResponse(response); //parse JSONS
    };

    buyClosedBatch = async (body, token) => {
        const { config, data } = this.parseConfig(body, token); //get base config for request
        const response = await axios.post(
            BASE_URL + BATCHES.BASE_PATH + BATCHES.BUY_CLOSED_BATCH,
            data,
            config
        );
        return this.parseResponse(response); //parse JSONS
    };
}

const service = new BatchesService();

export default service;
